#import "../fragments/invoice-template-fragment.graphql"

query GetInvoiceTemplate {
    invoiceTemplate {
        ...InvoiceTemplateFragment
    }
}
